var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaleasBw2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34_343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#CCCCCC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.19048,
    y: 0.190476,
    width: 35.619,
    height: 35.619,
    rx: 17.8095,
    stroke: "black",
    strokeWidth: 0.380952,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_34_343",
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9.5,
    width: 12,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 14,
    y: 9.5,
    width: 12,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4146 27.5H15.3281V9.98646H25.4146V13.0292H19.0417V16.8745H24.9714V19.9172H19.0417V24.4333H25.4146V27.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.4146 27.5H15.3281V9.98646H25.4146V13.0292H19.0417V16.8745H24.9714V19.9172H19.0417V24.4333H25.4146V27.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4146 27.5V27.881H25.7955V27.5H25.4146ZM15.3281 27.5H14.9472V27.881H15.3281V27.5ZM15.3281 9.98646V9.6055H14.9472V9.98646H15.3281ZM25.4146 9.98646H25.7955V9.6055H25.4146V9.98646ZM25.4146 13.0292V13.4101H25.7955V13.0292H25.4146ZM19.0417 13.0292V12.6482H18.6607V13.0292H19.0417ZM19.0417 16.8745H18.6607V17.2554H19.0417V16.8745ZM24.9714 16.8745H25.3523V16.4935H24.9714V16.8745ZM24.9714 19.9172V20.2981H25.3523V19.9172H24.9714ZM19.0417 19.9172V19.5362H18.6607V19.9172H19.0417ZM19.0417 24.4333H18.6607V24.8143H19.0417V24.4333ZM25.4146 24.4333H25.7955V24.0524H25.4146V24.4333ZM25.4146 27.119H15.3281V27.881H25.4146V27.119ZM15.7091 27.5V9.98646H14.9472V27.5H15.7091ZM15.3281 10.3674H25.4146V9.6055H15.3281V10.3674ZM25.0336 9.98646V13.0292H25.7955V9.98646H25.0336ZM25.4146 12.6482H19.0417V13.4101H25.4146V12.6482ZM18.6607 13.0292V16.8745H19.4226V13.0292H18.6607ZM19.0417 17.2554H24.9714V16.4935H19.0417V17.2554ZM24.5904 16.8745V19.9172H25.3523V16.8745H24.5904ZM24.9714 19.5362H19.0417V20.2981H24.9714V19.5362ZM18.6607 19.9172V24.4333H19.4226V19.9172H18.6607ZM19.0417 24.8143H25.4146V24.0524H19.0417V24.8143ZM25.0336 24.4333V27.5H25.7955V24.4333H25.0336Z",
    fill: "black",
    mask: "url(#path-3-outside-1_34_343)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_343",
    x: 0.47619,
    y: 0,
    width: 39.0476,
    height: 39.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.52381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.761905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_343",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaleasBw2);
export default __webpack_public_path__ + "static/media/TaleasBW2.d66253aa886aec40a1f77dc4132f4aad.svg";
export { ForwardRef as ReactComponent };